<div
    class="shadow-sm smallwidth cmps-widget-coaching-insight"
    [ngClass]="{ 'filter-window-opened': filterOpen === true }"
>
    <div
        class="card"
        role="complementary"
        [attr.aria-labelledby]="compConfig.id"
    >
        <div
            class="card-header"
            [id]="compConfig.id"
            role="heading"
            aria-level="2"
        >
            {{ compConfig.header }}
        </div>
        <div class="card-body">
            <div class="container-fluid">
                <div
                    *ngIf="dataFailed == true"
                    class="p-3 text-center"
                >
                    {{ i18n._711_NO_DATA_AVAILABLE | translate }}.
                </div>
                <div
                    class="coaching-for-subtitle text-center"
                    *ngIf="selectedFavouriteView"
                >
                    <span class="current-view-name"
                        >{{ i18n._7305_FOR | translate }}
                        {{ selectedFavouriteView.firstName }}
                        {{ selectedFavouriteView.lastName }}</span
                    >
                    <cmps-team-view
                        [selectedUser]="selectedFavouriteView"
                        (selectedUserChange)="
                            setCameFromFLOA(false);
                            handleCurrentViewChange($event)
                        "
                        dropdownPosition="right"
                        (isOpen)="moreOAMetricsOpened = !moreOAMetricsOpened"
                        [favourites]="favourites | async"
                        [currentView]="selectedFavouriteView"
                    >
                    </cmps-team-view>
                </div>

                <div
                    class="row"
                    *ngIf="config | async"
                >
                    <div class="col-12">
                        <cmps-coaching-component-strip
                            *ngIf="coachingComponents"
                            [coachingComponents]="coachingComponents"
                            [hasPendingData]="hasPendingData"
                            [hasPendingPeople]="hasPendingPeople"
                            (toggledComponent)="expandCoachingWidget($event)"
                        >
                            <div
                                dynamic-content
                                class="current-view-label col-6 col-md-3"
                            >
                                <div class="current-view-label-sec">
                                    <div class="current-view-date-range">
                                        <div
                                            class="date-range coaching-date-range d-block"
                                        >
                                            <label
                                                for="coachingInsightDateRange"
                                                >{{
                                                    i18n._709_DATE_RANGE
                                                        | translate
                                                }}</label
                                            >
                                            <ng-select
                                                [options]="dateRanges"
                                                [notFoundMsg]="
                                                    i18n._7413_NO_RESULTS_FOUND
                                                        | translate
                                                "
                                                [ngModel]="selectedPeriodType"
                                                [disabled]="
                                                    (rowExpanded | async) ==
                                                    true
                                                "
                                                (ngModelChange)="
                                                    periodTypeChanged($event)
                                                "
                                                forceDropdownPosition
                                            >
                                            </ng-select>
                                        </div>
                                        <div class="refresh-button-container">
                                            <button
                                                class="btn"
                                                [ngClass]="
                                                    (hasPendingRefresh | async)
                                                        ? 'checked-button'
                                                        : 'refresh-button'
                                                "
                                                (click)="updateOA()"
                                            >
                                                <span
                                                    class="refresh-icon cmps-cdk-d-flex"
                                                >
                                                    <cmps-icon
                                                        svgIcon="refresh"
                                                    ></cmps-icon>
                                                </span>
                                                <span
                                                    class="refresh-button-copy"
                                                    >{{
                                                        ((hasPendingRefresh
                                                        | async)
                                                            ? i18n._7474_GET_UPDATES
                                                            : i18n._7475_UP_TO_DATE
                                                        ) | translate
                                                    }}</span
                                                >
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </cmps-coaching-component-strip>
                    </div>
                </div>

                <!-- ###################  ADD COACHING COMPONENTS AS VIEWS HERE  ################### -->
                <div
                    class="row oapopulation"
                    *ngIf="
                        (people | async) &&
                        ((forceOpenTeamOA | async) == true ||
                            (coachingViewShortName | async) ==
                                CoachingComponentName.OA)
                    "
                >
                    <div class="col-12">
                        <button
                            *ngIf="cameFromFloa == true"
                            (click)="
                                setCameFromFLOA(false);
                                goBackToStoredFavourite()
                            "
                            class="btn legend-button back"
                        >
                            <cmps-icon svgIcon="reply"></cmps-icon>
                            <span>{{
                                i18n._7495_BACK_TO_PREVIOUS_VIEW | translate
                            }}</span>
                        </button>

                        <cmps-team-oa-metrics
                            [selectedUser]="favouriteView | async"
                            [oaPeople]="oaPeople"
                            (metricsRendered)="onMetricsRendered($event)"
                            (reorderedPeople)="setOaPeopleUsingService()"
                            (toggledDisplay)="setOaPeopleUsingService()"
                            (filterToggled)="filterOpen = $event"
                        >
                        </cmps-team-oa-metrics>
                    </div>
                </div>

                <div
                    class="row"
                    *ngIf="
                        (forceOpenTeamOA | async) == true ||
                        (coachingViewShortName | async) ==
                            CoachingComponentName.FLOA
                    "
                >
                    <div class="col-12">
                        <cmps-frontline-oa
                            [selectedUser]="favouriteView | async"
                            [floaData]="floa | async"
                            (selectedUserChange)="
                                handleCurrentViewChange(
                                    $event,
                                    true,
                                    CoachingComponentType.OA
                                )
                            "
                        >
                        </cmps-frontline-oa>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
